import { AiseaApiFactory } from "@/api/aisea/apiFactory";
import { storage } from "@/firebase/firebaseConfig";

export default {
  async fetchVessel(_, vesselId) {
    let res = await AiseaApiFactory.get("enterpriseVessel").fetchVessel(
      vesselId
    );
    //commit("SET_VESSEL", { vessel: res.data });
    return res.data;
  },

  async saveVessel(_, payload) {
    let res = await AiseaApiFactory.get("enterpriseVessel").save(payload);
    return res.data;
  },

  async fetchPictures({ commit }, payload) {
    commit("SET_FETCH_PICTURES_STATE", true);
    let res = await AiseaApiFactory.get("enterpriseVesselPicture").fetch(
      payload.vesselId
    );

    let tmpPictures = [];
    let media = {
      src: require("@/assets/images/no_image_bg.svg"),
      isAddButton: true
    };
    tmpPictures.push(media);
    for (const val of res.data) {
      let src = await storage.child(val.picture.original_path).getDownloadURL();
      let media = {
        src: src,
        isAddButton: false,
        picture: val
      };
      tmpPictures.push(media);
    }
    let lightBox = tmpPictures.filter(v => {
      return v.isAddButton === false;
    });
    commit("SET_LIGHT_BOX_PICTURES_PICTURES", lightBox);
    commit("SET_PICTURES", tmpPictures);
    commit("SET_FETCH_PICTURES_STATE", false);
    return true;
  },

  async addPicture({ commit, state }, payload) {
    let formData = new FormData();
    formData.append("data", payload.file);

    let resPicture = await AiseaApiFactory.get("picture").addVesselPicture({
      formData: formData
    });

    let resVesselPicture = await AiseaApiFactory.get(
      "enterpriseVesselPicture"
    ).linkTo(payload.vesselId, { id: resPicture.data.id, sort_order: 1 });

    await new Promise(resolve => setTimeout(resolve, 3000));

    let tmpPictures = state.pictures.concat();
    let src = await storage
      .child(resVesselPicture.data.picture.original_path)
      .getDownloadURL();
    let media = {
      src: src,
      isAddButton: false,
      picture: resVesselPicture.data
    };
    tmpPictures.splice(1, 0, media);

    let lightBox = tmpPictures.filter(v => {
      return v.isAddButton === false;
    });
    commit("SET_LIGHT_BOX_PICTURES_PICTURES", lightBox);
    commit("SET_PICTURES", tmpPictures);
    return true;
  },

  async deletePicture({ commit, state }, payload) {
    let res = await AiseaApiFactory.get("enterpriseVesselPicture").unlinkTo(
      payload.vesselId,
      payload.linkId
    );

    if (res) {
      let tmpPictures = state.pictures.concat();
      tmpPictures.splice( payload.index, 1 );
      let lightBox = tmpPictures.filter(v => {
        return v.isAddButton === false;
      });

      commit("SET_LIGHT_BOX_PICTURES_PICTURES", lightBox);
      commit("SET_PICTURES", tmpPictures);
    }
  }
};
